const isProduction: boolean = process.env.NODE_ENV === 'production'
const prefix = 'Invariant failed'

/** Throw an error if the condition fails */
export default function invariant(
  condition: unknown,
  message?: string,
): asserts condition {
  if (condition) {
    return
  }

  // In production we strip the message but still throw
  if (isProduction) {
    throw new Error(prefix)
  }

  throw new Error(`${prefix}: ${message || ''}`)
}
